import { Inject, Injectable } from '@angular/core';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { oldEnvironment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class TemplatesService {
	constructor(private dataService: OldDataService) {}

	data_format_bank(leadid) {
		const url = `${oldEnvironment.api}leads/data_chargeback.php`;
		return this.dataService.post(url, { leadId: leadid });
	}

	layaout_format_bank(leadid, canva, html) {
		const url = `${oldEnvironment.api}templates/create_template.php`;
		return this.dataService.post(url, {
			leadId: leadid,
			lead: canva,
			htmlLead: html,
		});
	}
}
